// Components
import MenuMain from '@/components/composite/Menu/MenuMain';
import MenuNotifications from '@/components/composite/Menu/MenuNotifications';
import MenuSettings from '@/components/composite/Menu/MenuSettings';
import Iconosquare from '@/components/icons/Iconosquare';
import LinkBase from '@/components/base/LinkBase';

// Hooks
import useUrlUserHomepage from '@/utils/hooks/user/useUrlUserHomepage';

const Menu = () => {
    const { userHomepage } = useUrlUserHomepage();

    return (
        <div className="navigation-menu hidden h-full w-auto flex-col items-center justify-between md:flex">
            <div className="flex p-5 align-middle">
                <LinkBase href={userHomepage} className="inline-block leading-none">
                    <Iconosquare size={35} className="hidden text-icoBlue md:block" />
                </LinkBase>
            </div>
            <MenuMain />
            <div className="flex flex-col items-center space-y-5 px-3.5 py-5">
                <MenuNotifications />
                <MenuSettings />
            </div>
        </div>
    );
};

export default Menu;
